export const environmentStages = [
	"dev",
	"acc",
	"prod",
] as const;
export type EnvironmentStage = typeof environmentStages[number];
